
import { defineComponent, PropType } from 'vue'
import { IssueSeverity } from '~/types/types'
import { getIssueSeverityIcon, getIssueSeverityIconColor, getIssueSeverityLabel } from '~/utils/ui'

/**
 * Component to severity wise tag
 */
export default defineComponent({
  name: 'IssueSeverityTag',
  props: {
    severity: {
      type: String as PropType<IssueSeverity>,
      required: true
    },
    spacing: {
      type: String,
      default: 'gap-x-1.5'
    }
  },
  computed: {
    label(): string {
      return getIssueSeverityLabel(this.severity)
    },
    iconType(): string {
      return getIssueSeverityIcon(this.severity)
    },
    iconColor(): string {
      return getIssueSeverityIconColor(this.severity)
    }
  }
})
